import React, { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';

import PlanUpgradeButton from 'components/PlanUpgradeButton';

class CustomFieldsUpgradeNotice extends PureComponent {
    render() {
        const { t } = this.props;

        return (
            <p className="custom-field-upgrade-notice dimmed-text">
                <Trans
                    i18nKey="billing:upgrade.customFields"
                    components={{
                        title: <strong />,
                        button: <PlanUpgradeButton reason="customFields" />,
                        learnMore: <a href="http://help.niftypm.com/en/articles/3938415-custom-fields-types-for-project-management" target="_blank" rel="noopener noreferrer" />
                    }}
                    values={{ plan: t('plans.Starter.title') }}
                />
            </p>
        )
    }
}

export default withTranslation('billing')(CustomFieldsUpgradeNotice);
